'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCurrencyConversionsIfNeeded = exports.changeCurrentCurrency = exports.getCurrentCurrency = exports.isCurrencyConversionsLoading = exports.getCurrencyConversions = exports.CHANGE_CURRENCY = exports.LOAD_CURRENCY_CONVERSION_SUCCESS = exports.LOAD_CURRENCY_CONVERSION_REQUEST = exports.LOAD_CURRENCY_CONVERSION_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CURRENCY_CONVERSION_FAIL = exports.LOAD_CURRENCY_CONVERSION_FAIL = 'la/ui/currency/LOAD_FAIL';
var LOAD_CURRENCY_CONVERSION_REQUEST = exports.LOAD_CURRENCY_CONVERSION_REQUEST = 'la/ui/currency/LOAD_REQUEST';
var LOAD_CURRENCY_CONVERSION_SUCCESS = exports.LOAD_CURRENCY_CONVERSION_SUCCESS = 'la/ui/currency/LOAD_SUCCESS';
var CHANGE_CURRENCY = exports.CHANGE_CURRENCY = 'la/ui/currency/CHANGE';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

// reducer
var DEFAULT_STATE = {
    conversions: [],
    currentCurrency: 'usd',
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_CURRENCY:
            return (0, _extends3.default)({}, state, {
                currentCurrency: action.payload
            });
        case LOAD_CURRENCY_CONVERSION_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_CURRENCY_CONVERSION_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_CURRENCY_CONVERSION_SUCCESS:
            return (0, _extends3.default)({}, state, {
                conversions: action.payload.conversions,
                loaded: action.meta.actionTime,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.currency;
};

var currencyConversionsSelector = (0, _reselect.createSelector)(stateSelector, function (currency) {
    return currency.conversions;
});

var getCurrencyConversions = exports.getCurrencyConversions = (0, _reselect.createSelector)(currencyConversionsSelector, function (conversions) {
    return conversions;
});

var getLoadTimeForCurrencyConversions = (0, _reselect.createSelector)(stateSelector, function (currency) {
    return currency.loaded || 0;
});
var isCurrencyConversionsLoading = exports.isCurrencyConversionsLoading = (0, _reselect.createSelector)(stateSelector, function (currency) {
    return currency.loading || false;
});
var getCurrentCurrency = exports.getCurrentCurrency = (0, _reselect.createSelector)(stateSelector, function (currency) {
    return currency.currentCurrency;
});

var shouldFetchCurrencyConversions = function shouldFetchCurrencyConversions(state) {
    var loaded = getLoadTimeForCurrencyConversions(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isCurrencyConversionsLoading(state);
};

/* ACTION CREATORS */
var loadCurrencyConversions = function loadCurrencyConversions() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: LOAD_CURRENCY_CONVERSION_REQUEST
                            });
                            _context.next = 6;
                            return _api.CurrencyConversions.fetchCurrencyConversions({ deployment: deployment });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_CURRENCY_CONVERSION_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_CURRENCY_CONVERSION_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var changeCurrentCurrency = exports.changeCurrentCurrency = function changeCurrentCurrency(currency) {
    return {
        payload: currency,
        type: CHANGE_CURRENCY
    };
};

var fetchCurrencyConversionsIfNeeded = exports.fetchCurrencyConversionsIfNeeded = function fetchCurrencyConversionsIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchCurrencyConversions(getState())) {
            return dispatch(loadCurrencyConversions());
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/currency.js
// module id = TZ7S
// module chunks = 60